export enum TabPaneStatusEnum {
  Reader = "1",
  Antenna = "2",
}

export const accessPointOptionsReader = [
  { id: 1, description: "Entrada Raio" },
  { id: 2, description: "Entrada e Saída Raio" },
  { id: 3, description: "Entrada SubRaio/Portaria" },
  { id: 4, description: "Entrada e Saída SubRaio/Portaria" },
  { id: 5, description: "Entrada Armazém" },
  { id: 6, description: "Entrada e Saída Armazém" },
  { id: 7, description: "Saída Armazém" },
  { id: 8, description: "Saída SubRaio/Portaria" },
  { id: 9, description: "Saída Raio" },
];

export const accessPointOptionsAntenna = [
  { id: 1, description: "Entrada Raio" },
  { id: 2, description: "Entrada Subraio/Portaria" },
  { id: 3, description: "Entrada Armazém" },
  { id: 4, description: "Saída Armazém" },
  { id: 5, description: "Saída SubRaio/Portaria" },
  { id: 6, description: "Saída Raio" },
];

export const sectorOptions = [
  { id: 1, description: "Descartável" },
  { id: 2, description: "Insumos" },
  { id: 3, description: "Retornável" },
  { id: 4, description: "Chopp" },
  { id: 5, description: "NANC" },
  { id: 6, description: "Colaborativo" },
  { id: 7, description: "CDR/CDI" },
  { id: 8, description: "Estacionamento/Pátio" },
];

export const selectAntennaNumberList = [
  { id: 1, description: "1" },
  { id: 2, description: "2" },
  { id: 3, description: "3" },
  { id: 4, description: "4" },
];

export const flowOptions = [
  { id: 1, description: "Entrada" },
  { id: 2, description: "Saída" },
];

export const selectReaderModelList = [
  { id: 1, description: "M6" },
  { id: 2, description: "EDGE-30R" },
  { id: 3, description: "EDGE-30R+" },
];
